export default __webpack_public_path__ + "static/media/a026-example6.406353d8.jpg";